import React, {Proptype, Component} from 'react'
import {connect} from 'react-redux'
import OnBoardingNatural from 'template/OnBoardingNatural';
import { onBoardingContents } from './constant';
import {fetchPosterList} from './ducks'
import PosterList from './PosterList';
import Loading from 'components/UI/Loading';
import { STATE } from 'controllers/poster/updatePoster';
import { browserHistory, Link } from 'react-router'
import { confirm } from 'util/confirm';
import { alert } from 'util/alert';
import unlinkPoster from 'controllers/poster/unlinkPoster';
import deletePoster from 'controllers/poster/deletePoster';
import Pagination from "react-js-pagination";

const mapStateToProps = (state) => ({
  user: state.user,
  gSubscription: state.gSubscription,
  posterList: state.posterList
})

const DEFAULT_AMOUNT_PER_PAGE = 12
const locale = {
  id: 'PosterList',
  code: 'CN',
  text: {
    'There is at least one order made under the post. You cannot delete a post with an order.': '此海报已有人报名。无法删除。',
    'There is at least one order made under the post. You cannot unlink a post with an order.': '此海报已有人报名。无法下架。'
  }
}

class DefaultTab extends Component {
  constructor(props){
    super(props);
    this.state = {
      activePage: 1
    }
    this.fetchPosterList = this.fetchPosterList.bind(this);
    this.unlinkPoster = this.unlinkPoster.bind(this);
    this.deletePoster = this.deletePoster.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  componentWillMount(){
    this.fetchPosterList();
  }

  fetchPosterList() {
    let {
      dispatch,
      posterState
    } = this.props
    const schoolId = localStorage.getItem('schoolId')
    dispatch(fetchPosterList(schoolId, STATE.indexOf(posterState), DEFAULT_AMOUNT_PER_PAGE, this.state.activePage))
  }
  handlePageChange(pageNumber){
    const {dispatch, posterState} = this.props
    const schoolId = localStorage.getItem('schoolId')

    this.setState({activePage: pageNumber},()=>{
      dispatch(fetchPosterList(schoolId, STATE.indexOf(posterState), DEFAULT_AMOUNT_PER_PAGE, this.state.activePage))      
    });
  }
  onSelect(poster) {
    browserHistory.push(`/poster-preview/${poster.id}`);
  }

  deletePoster(id) {
    let {
      dispatch,
    } = this.props;


    return ()=>{
      confirm(__('Are you sure you want to delete the poster?', 'poster'), __('Delete', 'poster'))
      .then(()=>{
        deletePoster(id)
        .then((res)=>{
          if (res.result === "success") {
            this.fetchPosterList();
          }else {
            alert.fail(__('There is at least one order made under the post. You cannot delete a post with an order.', locale));            
          }
        })
      })
      .catch((err) => {console.log(err)})
    }

  }

  unlinkPoster(id) {
    let {
      dispatch,
    } = this.props;

    return ()=>{
      confirm(__('Are you sure you want to unlink the poster? The link will become invisible.', 'poster'), __('Unlink', 'poster'))
      .then(()=>{
        unlinkPoster(id)
        .then((res)=>{
          const {result, reason} = res;
          if (result === "success") {
            this.fetchPosterList();
          }
          if (result === "failure" && reason === "The poster ticket(s) have(s) been ordered.") {
            alert.fail(__('There is at least one order made under the post. You cannot unlink a post with an order.', locale));
          }
        });
      });
    }
  }

  render(){
    let { posterState, posterList } = this.props;
    let { count, fetching, list, hasPermission, school_has_poster } = posterList

    const content = onBoardingContents[posterState] || {};

    if(fetching){
      return(
        <Loading onPanel={true} />
      )
    }

    if((content && school_has_poster == 0) || !hasPermission){
      return(
        <OnBoardingNatural
          isShown={true}
          title={content.title}
          text={content.text}
          image={content.image}
          showArrow={content.showArrow}
        />
      )
    } else {
      return (
        <div className='poster--list--container'>
          <div className="row">
            <PosterList
              list={list}
              count={count}
              onSelect={this.onSelect}
              onDelete={this.deletePoster}
              onUnlink={this.unlinkPoster}
              onFetch={this.fetchPosterList}
            />
          </div>
          <Pagination
            innerClass='pagination pull-right'
            activePage={this.state.activePage}
            itemsCountPerPage={DEFAULT_AMOUNT_PER_PAGE}
            totalItemsCount={count}
            pageRangeDisplayed={5}
            onChange={this.handlePageChange}
          />
        </div>
      )
    }
  }
}


export default connect(mapStateToProps)(DefaultTab)



// WEBPACK FOOTER //
// ./src/containers/pages/Poster/DefaultTab.js